module.exports = __webpack_public_path__ + "img/s_pow20-logo.fa69dab.png";